/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { Configure, Environments, Logger, Properties, Utility } from "@/frameworks/libraries";
import Language from "@rfice/language";
// import { usePersistStore } from "@/frameworks/core/persistence";

import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

Logger.install();
Properties.property;

const params = new URLSearchParams(location.search);
if (params.has("l")) {
	Configure.useLanguage = params.get("l") as LanguageType;
	console.log("#index# useLanguage", Configure.useLanguage, params.get("l"));
}

const version = Environments.env("ROOT_VERSION") as string;
Language.initialize("Application", version, false, Configure.useLanguageDebug).then(async () => {
	await Language.change(Configure.useLanguage);
	// if (!location.pathname.includes("tools/viewer") && !Utility.isMobile) {
	// 	await usePersistStore.persist.rehydrate();
	// }

	import(
		Configure.isPartners
			? "./bootstrap_partneradmin"
			: location.pathname.includes("tools/viewer")
				? "./bootstrap_fileviewer"
				: Utility.isMobile
					? "./bootstrap_mobile"
					: "./bootstrap_main"
	);
});
